// extracted by mini-css-extract-plugin
export default {"icon":"ytiFJ9Oc9I_pdp"};